import { createBrowserHistory } from 'history';
export default createBrowserHistory();

// import createHistory from 'history/createBrowserHistory'

// export default createHistory()
